export default __webpack_public_path__ + "static/fist-85c70d308c5c0d180cda4682f564a52a.jpeg";